import { render } from "./signupComponent.vue?vue&type=template&id=6cbc5c61&scoped=true"
import script from "./signupComponent.vue?vue&type=script&lang=js"
export * from "./signupComponent.vue?vue&type=script&lang=js"

import "./signupComponent.vue?vue&type=style&index=0&id=6cbc5c61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbc5c61"]])

export default __exports__